import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResponsePackage } from "../models/util.model";
import { Region } from "../models/region.model";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";

@Injectable({
    providedIn: 'root'
  })
export class RegionService {
    
    private pathApi: string;
    private headers = new HttpHeaders({'Content-Type': 'application/json'});


    constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
        this.pathApi = this.config.pathApi + "region/";
    }

    public getAllForSelectNoUser(utilityId: number | null = null) {
        if(utilityId) {
            return this.http.get<ResponsePackage<Region[]>>(`${this.pathApi}getAllForSelectNoUser/${utilityId}`,{headers: this.headers, observe: 'response'});
        }
        else {
            return this.http.get<ResponsePackage<Region[]>>(`${this.pathApi}getAllForSelectNoUser`,{headers: this.headers, observe: 'response'});
        }
    }

    public getAllForSelect(utilityId: number | null = null) {
        if(utilityId) {
            return this.http.get<ResponsePackage<Region[]>>(`${this.pathApi}getAllForSelect/${utilityId}`,{headers: this.headers, observe: 'response'});
        }
        else {
            return this.http.get<ResponsePackage<Region[]>>(`${this.pathApi}getAllForSelect`,{headers: this.headers, observe: 'response'});
        }
    }

    getAll(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getAll`, dataIn, {observe: 'response'});
    }

    save(region: Region): Observable<any> {
        return this.http.post(`${this.pathApi}save`, region, {observe: 'response'});
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.pathApi}delete/${id}`, {observe: 'response'});
    }
}